"use client"

interface CheckBoxProps {
  width?: number
  height?: number
  checked: boolean
  checkedColor: string
  border: {
    color: string
    borderWidth: string
    radius: string
  }
  onChange: (checked: boolean) => void
}

const CheckBox = ({ width, height, checked, checkedColor, border, onChange }: CheckBoxProps) => {
  return (
    <input
      type="checkbox"
      className="min-w-[20px] min-h-[20px] cursor-pointer appearance-none relative "
      checked={checked}
      onChange={() => onChange(!checked)}
      style={
        {
          "--width": width,
          "--height": height,
          borderColor: checked ? checkedColor : border.color,
          borderWidth: border.borderWidth,
          borderRadius: border.radius,
          backgroundColor: checked ? checkedColor : "transparent",
          backgroundImage: checked ? 'url("/icons/checked.svg")' : "none",
          backgroundPosition: "center",
          backgroundSize: "14px 14px",
          backgroundRepeat: "no-repeat",
        } as React.CSSProperties
      }
    />
  )
}

export default CheckBox
